"use client";

import { Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
export default function Testimonials() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const testimonials = [{
    quote: "The NoMoCo Pillow has been an essential tool in our neuroimaging research. It provides unparalleled stability and patient comfort, which is critical for high-resolution MRI studies.",
    name: "Lisa Marie Langevin, PhD",
    role: "University of Calgary"
  }, {
    quote: "We have found the NoMoCo system to be highly effective in reducing motion artifacts. Its design is intuitive for technicians and significantly improves the quality of our clinical data.",
    name: "Mazyar E. Ahmadi, MD",
    role: "Harvard Medical School"
  }, {
    quote: "Consistency in positioning is key for longitudinal research. NoMoCo pillows ensure that our subjects are positioned identically across multiple scanning sessions.",
    name: "Susan Tapert, PhD",
    role: "University of California, San Diego"
  }, {
    quote: "The durability and ease of cleaning make NoMoCo the preferred choice for our high-volume sleep and imaging research protocols.",
    name: "Sean P.A. Drummond, PhD",
    role: "Monash University"
  }];
  return <section data-section-id="14383" id="researchtestimonials" className="bg-background py-28 md:py-36 border-b-2 border-border">
      <div className="mx-auto max-w-[1320px] px-5 md:px-8">
        {}
        <div ref={headerRef} className={`grid grid-cols-12 gap-6 mb-16 md:mb-20 transition-all duration-500 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="col-span-12 md:col-span-8">
            <div className="font-default text-xs font-semibold uppercase tracking-[0.14em] text-primary mb-6">
              {"// CLINICAL FEEDBACK"}
            </div>
            <h2 className="font-default font-extrabold text-foreground leading-[0.96] tracking-[-0.03em] text-[clamp(2.25rem,4.5vw,4rem)]">
              Trusted by professionals.
            </h2>
          </div>
          <div className="hidden md:block md:col-span-4" aria-hidden="true" />
        </div>

        {}
        <div ref={gridRef} className={`transition-all duration-500 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full max-w-4xl mx-auto">
            <CarouselContent>
              {testimonials.map((item, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col items-center text-center px-4 md:px-12 py-8">
                    <div className="mb-8">
                      <Quote className="text-primary/40" strokeWidth={1.5} style={{
                    width: "3.5rem",
                    height: "3.5rem"
                  }} aria-hidden="true" />
                    </div>

                    <blockquote className="font-default text-foreground text-xl md:text-3xl font-medium leading-[1.4] tracking-[-0.01em] mb-10">
                      "{item.quote}"
                    </blockquote>

                    <div className="flex flex-col items-center">
                      <div className="h-px w-12 bg-primary mb-6" />
                      <cite className="not-italic">
                        <span className="block font-default text-foreground font-bold text-lg md:text-xl">
                          {item.name}
                        </span>
                        <span className="block font-default text-muted-foreground text-sm md:text-base mt-1 uppercase tracking-wider">
                          {item.role}
                        </span>
                      </cite>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block">
              <CarouselPrevious className="border-2 border-border hover:bg-accent hover:text-accent-foreground rounded-lg" />
              <CarouselNext className="border-2 border-border hover:bg-accent hover:text-accent-foreground rounded-lg" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}